import React, { useEffect, useState } from "react";
import { blockTypes, IBlock } from "../../../../interfaces/story";
import { mdiFullscreen, mdiFullscreenExit } from '@mdi/js';
import { useTranslation } from "react-i18next";
import Icon from "@mdi/react";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

interface IProps {
    addBlockToStory: Function
    data: IBlock | boolean
    setFullScreen?: Function
}

export default function TextBlockInput(props: IProps) {

    const [value, setValue] = useState('');    
    const [clickedIcon, setClickedIcon] = useState('');
    const [clickedText, setClickedText] = useState('');

    const { t } = useTranslation();

    useEffect(() => {
        if(props.data) {
            setValue((props.data as IBlock).data);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    const toolbarOptions = [
        [{ 'header': [1, 2, 3, false] }],        
        ['bold', 'italic', 'underline'],
        ['link'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ];    

    const modules = {
        toolbar: toolbarOptions,
    };

    function addToStory() {

        props.addBlockToStory({data:value, type:blockTypes.TEXT})
        setValue('');
    }
   
    const handleClick = () => {
        //props.setFullScreen((prev: boolean) => !prev)
        clickedIcon ? setClickedIcon('') : setClickedIcon(mdiFullscreenExit);
        clickedText ? setClickedText('') : setClickedText(t("Exit fullscreen"));
      };

    return(
        <div className="quill-editor-container">
            {<ReactQuill theme="snow" style={{ minHeight: '120px' }} value={value} modules={modules} placeholder={t("Add text...")} onChange={setValue}/>}
                <button className="default-button" onClick={() => addToStory()}>{t("Add to Story")}</button>
                <span onClick={handleClick} className="edit-in-fullscreen-icon"><Icon size={1} path={clickedIcon || mdiFullscreen} />{clickedText || t("Edit in fullscreen")}</span>
        </div>
        )
}